import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQueryClient, useMutation } from 'react-query';

function useSupportTicket() {
  const { privateFetch } = useContext(FetchContext);
  const queryClient = useQueryClient();
  function createTicketReply({ ticketId, ...payload }) {
    return privateFetch.post(`/v1/admin/ticket/${ticketId}/support`, payload);
  }

  function closeTicket({ ticketId, ...payload }) {
    return privateFetch.put(`/v1/admin/ticket/${ticketId}/support/close`, payload);
  }

  function manageSupportTicket(data) {
    if (data.isClose) {
      return closeTicket(data);
    }
    return createTicketReply(data);
  }

  return useMutation(manageSupportTicket, {
    onSuccess() {},
    onError() {},
    onSettled() {
      queryClient.invalidateQueries('support-tickets');
      queryClient.invalidateQueries('support-ticket-getResource');
    },
  });
}

export default useSupportTicket;
